export class Coordinate {
    latitude: number;
    longitude: number;
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/core/coordinate.ts